import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import VariableProximity from '../../blocks/TextAnimations/VariableProximity/VariableProximity';
import './Header.css';

const Header: React.FC = () => {
  // Using a type assertion to make TypeScript happy
  const headerRef = useRef<HTMLElement>(null);

  return (
    <header className="header" ref={headerRef as React.RefObject<HTMLElement>}>
      <div className="logo-container">
        <Link to="/">
          <img src="/images/logos/seem_logo_b.png" alt="SeeMuseums Logo" className="logo" />
        </Link>
        <VariableProximity
          label="SeeMuseums"
          fromFontVariationSettings="'wght' 500"
          toFontVariationSettings="'wght' 800"
          containerRef={headerRef as React.RefObject<HTMLElement>}
          className="company-name"
          radius={100}
          falloff="exponential"
        />
      </div>
      <nav className="navigation">
        <ul>
          <li><a href="/#features">Features</a></li>
          <li><a href="/#pricing">Pricing</a></li>
          <li><a href="https://forms.gle/KwPbb5GEfBE56xxz8" target="_blank" rel="noopener noreferrer">Support</a></li>
          <li><a href="/#footer">Contact</a></li>
        </ul>
      </nav>
      <a href="https://testflight.apple.com/join/r6bUD8q1" target="_blank" rel="noopener noreferrer" className="header-app-button">
        Get it on App Store
      </a>
    </header>
  );
};

export default Header; 